module.exports = __webpack_public_path__ + "media/images/menu-queries-active-icon-65c2436be5a408f511efbb336a6720bb.svg";